exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UpsellClinic_page_iframe{overflow:hidden;display:block;position:absolute;height:101vh;width:100%;top:-2px}@media only screen and (max-width: 768px){.UpsellClinic_page_iframe{margin-left:40px}}\n", ""]);

// Exports
exports.locals = {
	"page_iframe": "UpsellClinic_page_iframe"
};